import React, { useContext } from 'react';
import { Box, Typography, Paper, ThemeProvider, Theme } from '@mui/material';
import { UiContext } from 'uiContext';
import { employeeColors } from 'mobx/dashboards/employeeStore/_adapters';

export default function EmployeeTooltip({
  theme,
  by_coworkers,
  by_lead,
  by_subordinates,
  avg,
  date,
  colorize,
}: {
  theme: Theme;
  by_coworkers: number | null;
  by_lead: number | null;
  by_subordinates: number | null;
  avg?: number | null;
  date: string;
  colorize?: boolean;
}) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box>
          <Typography
            variant="f22"
            sx={{
              color: theme.palette.custom.fontColor,
            }}
          >
            {date}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: sp.s30,
            marginTop: sp.s30,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: 1,
                gap: sp.s30,
              }}
            >
              <Typography
                variant="f14"
                sx={{
                  color: !colorize
                    ? theme.palette.custom.fontColorNotActive
                    : employeeColors['by_lead'],
                }}
              >
                Руководитель:
              </Typography>

              <Typography
                variant="f16"
                sx={{
                  color: theme.palette.custom.fontColor,
                }}
              >
                {by_lead ? by_lead : '-'}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: sp.s30,
                width: 1,
              }}
            >
              <Typography
                variant="f14"
                sx={{
                  color: !colorize
                    ? theme.palette.custom.fontColorNotActive
                    : employeeColors['by_coworkers'],
                }}
              >
                Коллеги:
              </Typography>

              <Typography
                variant="f16"
                sx={{
                  color: theme.palette.custom.fontColor,
                }}
              >
                {by_coworkers ? by_coworkers : '-'}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: 1,
                gap: sp.s30,
              }}
            >
              <Typography
                variant="f14"
                sx={{
                  color: !colorize
                    ? theme.palette.custom.fontColorNotActive
                    : employeeColors['by_subordinates'],
                }}
              >
                Подчинённые:
              </Typography>
              <Typography
                variant="f16"
                sx={{
                  color: theme.palette.custom.fontColor,
                }}
              >
                {by_subordinates ? by_subordinates : '-'}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: 1,
                gap: sp.s30,
              }}
            >
              <Typography
                variant="f14"
                sx={{
                  color: !colorize
                    ? theme.palette.custom.fontColorNotActive
                    : employeeColors['avg'],
                }}
              >
                Средняя:
              </Typography>
              <Typography
                variant="f16"
                sx={{
                  color: theme.palette.custom.fontColor,
                }}
              >
                {avg ? avg : '-'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
